import styled from 'styled-components'
import Card from '../juegos/card.jsx';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import Tooltip from '@mui/material/Tooltip';
import { formatFecha } from "../../services/utilities.js"


const Container=styled.div`
	display:flex;  
  border-radius:5px 15px 15px 5px;    
  background-color:black;
  height:29vh;
  min-height:175px; 
  color:white;
  z-index:1;
  transition:width 500ms;
  min-width:530px;
  width:42vw;
  overflow:hidden;
  position:relative;
  margin:15px

  

`;
const ContainerCard=styled.div`
  min-width:175px;
  width:35%;
  height:100%
`;

const Revender=styled.div`
  display:flex;
  position:absolute;
  right:5px;
  top:5px;
  font-size:10px;
  align-items:center;
  z-index:1

`;

const Titulo=styled.div`
  font-size:18px;
  font-family:'Poppins', 'sans-serif';
  text-align:center;
`;


const CardDescription=styled.div`
  color:white;
  position:relative;  
  display:flex;
  flex-direction:column;
  justify-content:space-evenly;
  align-items:center;
  width:65%;
  min-width:200px;
  height:100%;
  
`;

const Overlay=styled.div`
  background-position:center;
  background-size:cover;
  position:Absolute;
  width:110%;
  height:100%;
  z-index:-1;
  opacity: 0.2;


`;


export default function GameCard(props){
	let {reventa } = props;

  let wasapNumber=955058179;
  let msj=`Hola, deseo revender mi juego con ID: ${reventa.id}`;
  let urlWhatsApp =`https://api.whatsapp.com/send?phone=${wasapNumber}&text=${encodeURIComponent(msj)}`;
  

  let activarReventa=async()=>{
    if(window.confirm("deseas ofrecer tu juego?")){
      try{

        window.open(urlWhatsApp, '_blank', 'width=600,height=900');
       /* dispatch(solicitudesEstado(1));
        await api.post(`/reventa/activate?id=${reventa.id}`);
        
        if(reventa.tipo_cuenta===2){
          await api.patch(`/reventa`,{id:reventa.id,permiso:true} );
        };
        dispatch(solicitudesEstado(0));*/

      }catch(err){alert("error en ofrecer el juego")}
    }
  }
 
	return(
		<Container >
             
			        <ContainerCard>
                <Card consola={reventa.consola} poster={reventa.Cuenta_Juego.Juego.poster}/>
              </ContainerCard>
              {reventa?
                <CardDescription>          
                 {                  
                  !reventa.publicar_reventa?
                  <Tooltip title="Revender" >
                    <Revender onClick={activarReventa}>
                      <ShoppingCartCheckoutIcon sx={{fontSize:"25px",color:"yellow"}}/> Revender
                    </Revender>
                  </Tooltip>:null
                }
                <Overlay style={{backgroundImage:`url(${reventa.Cuenta_Juego.Juego.poster})`}}/>                    
                <Titulo >
                  <b >{reventa.Cuenta_Juego.Juego.nombre}</b>
                </Titulo>
                    <div>tipo de cuenta :{reventa.tipo_cuenta===1?" Primaria":" Secundaria"}</div>
                    <div>fecha de adquisicion :{formatFecha(reventa.createdAt)}</div>
                    <div>id: {reventa.id}</div>
                </CardDescription>:null}
		</Container>)
}